import Vue from 'vue'
import axios from 'axios'
import router from '../router/index'
// import { app } from '../modules/index/index'
// import { isHas, configApi } from 'assets/js/common'

Vue.prototype.$http = axios

let vm = new Vue()
let configPath //保存接口IP

// const devUrl = 'http://192.168.31.27:4567/api/rest';
// const devUrl = 'http://122.114.174.114:80/api/rest';
// const devUrl = 'http://fbi.5ifbi.com:12345/api/rest';
const devUrl = 'https://help.tizdata.com/api/rest';
// const devUrl = 'http://fbi.5ifbi.com:8000/api/rest';
// const devUrl = 'http://bi-test.maipeijian.net/api/rest/';
// const devUrl = 'https://handinhand.cnpc.com.cn/api/rest';

if (process.env.NODE_ENV === 'production') {
  configPath = devUrl;
} else {
  configPath = devUrl;
  // configPath = "api";
}

vm.$http.interceptors.request.use(
  config => {
    //!router.app.$route.query.uid && 
    if (localStorage.getItem("token")) { //有分享uid不验证token
      config.headers.Authorization = `token ${localStorage.getItem("token")}`
    }
    return config
  },
  err => {
    return Promise.reject(err)
  },
)

vm.$http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          //401 清除token信息并跳转到登录页面
          localStorage.removeItem("token");
          if (router.currentRoute.path != "/install_config") {
            if (router.app.$route.query.uid) {
              location.reload()
            } else { //只有在当前路由不是登录页面和分享页面才跳转
              if (router.currentRoute.path !== 'login' && window.top) {
                window.top.location.replace(location.origin)
              } else {
                router.currentRoute.path !== 'login' &&
                  router.replace({
                    path: 'login'
                  })
              }
            }
          }
      }
    }
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return Promise.reject(error.response)
  },
)

export class Utils {
  post(url, data, isEmit) {
    url = configPath + url;
    return new Promise((resolve, reject) => {
      vm.$http({
        method: 'POST',
        url: url,
        data: data,
        timeout: 60000,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        }
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        // let statusText = error.response.statusText; //接口异常
        // let status = error.response.status; //状态
        // if (!isHas(isEmit)) { // 如果没有传第三个参数则进行派送
        //   app.$root.$emit('error', error); //派送权限执行成功
        // }
        reject(error);
        // layerMsg(statusText + " 异常状态：" + status)
      });
    })
  }
  get(url, data, isEmit) {
    url = configPath + url;
    return new Promise((resolve, reject) => {
      vm.$http({
        method: 'GET',
        url: url,
        timeout: 60000,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        params: data
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        // let statusText = error.response.statusText; //接口异常
        // let status = error.response.status; //状态
        // if (!isHas(isEmit)) { // 如果没有传第三个参数则进行派送
        //   app.$root.$emit('error', error); //派送权限执行成功
        // }
        reject(error);
        // layerMsg(statusText + " 异常状态：" + status)
      });
    })
  }
  put(url, data, isEmit) {
    url = configPath + url;
    return new Promise((resolve, reject) => {
      vm.$http({
        method: 'PUT',
        url: url,
        data: data,
        timeout: 60000,
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        }
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        // let statusText = error.response.statusText; //接口异常
        // let status = error.response.status; //状态
        if (!isHas(isEmit)) { // 如果没有传第三个参数则进行派送
          app.$root.$emit('error', error); //派送权限执行成功
        }
        reject(error);
        // layerMsg(statusText + " 异常状态：" + status)
      });
    })
  }
  patch(url, data, isEmit) {
    url = configPath + url;
    return new Promise((resolve, reject) => {
      vm.$http({
        method: 'PATCH',
        url: url,
        data: data,
        timeout: 60000,
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        }
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        // let statusText = error.response.statusText; //接口异常
        // let status = error.response.status; //状态
        if (!isHas(isEmit)) { // 如果没有传第三个参数则进行派送
          app.$root.$emit('error', error); //派送权限执行成功
        }
        reject(error);
        // layerMsg(statusText + " 异常状态：" + status)
      });
    })
  }
  deletePort(url, data, isEmit) {
    url = configPath + url;
    return new Promise((resolve, reject) => {
      vm.$http({
        method: 'DELETE',
        url: url,
        timeout: 60000,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        params: data
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        // let statusText = error.response.statusText; //接口异常
        // let status = error.response.status; //状态
        if (!isHas(isEmit)) { // 如果没有传第三个参数则进行派送
          app.$root.$emit('error', error); //派送权限执行成功
        }
        reject(error);
        // layerMsg(statusText + " 异常状态：" + status)
      });
    })
  }
  getLocal(url, data) {
    return new Promise((resolve, reject) => {
      vm.$http({
        method: 'GET',
        url: url,
        timeout: 60000,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        params: data
      }).then(function (response) {
        resolve(response);
      }).catch(function (error) {
        reject(error);
      });
    })
  }
}
export default {
  configPath
}
